module.exports = __webpack_public_path__ + "static/img/left-navigation-logo.3c8af51.svg";


//////////////////
// WEBPACK FOOTER
// ./static/prism/images/left-navigation-logo.svg
// module id = T1+0
// module chunks = 76